import { Flex, Typography, TypographyChildren } from '@aloft/toolkit-sui';

type Props = {
  title: TypographyChildren;
  body: TypographyChildren;
};

export function ErrorPageLayout({ title, body }: Props) {
  return (
    <Flex
      width="100%"
      height="100%"
      padding={2.5}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap={5}
    >
      <Typography variant="h1">{title}</Typography>
      <Typography>{body}</Typography>
    </Flex>
  );
}
